
import { mapGetters } from "vuex";
// import UiBreadcrumbs from "@/components/UI/UiBreadcrumbs.vue";
import BlocksContainer from "~/components/blocks/BlocksContainer";
import CatalogList from "@/components/common/CatalogList.vue";
import { getImageByPosition, metaGenerator } from "@/utils";
import googleAnalyticsEvents from "~/mixins/googleAnalyticsEvents.js";
import jsonLdMixin from "~/mixins/jsonLdMixin";
import useEvents from "~/mixins/useEvents";

export default {
  components: {
    // UiBreadcrumbs,
    BlocksContainer,
    CatalogList,
  },
  mixins: [googleAnalyticsEvents, jsonLdMixin, useEvents],
  async asyncData({ error, $api, params, store, route, i18n }) {
    const getPage = async () => {
      try {
        const { data } = await $api.pages.getPage(params?.pathMatch);
        return data.data;
      } catch (err) {
        let statusCode = null;
        const isUnescapedCharacters = err?.code === "ERR_UNESCAPED_CHARACTERS";
        isUnescapedCharacters
          ? (statusCode = 404)
          : (statusCode = err.response?.status);
        console.log("err - ", err?.response?.data);
        error({ statusCode });
      }
    };
    await store.dispatch("general/fetchCollectionList");
    const splitedPath = route.path.split("/");
    const collectionsList = store.state.general.collectionList || [];
    const collectionSlug =
      i18n.locale === i18n.defaultLocale ? splitedPath[1] : splitedPath[2];
    const currentCollection = collectionsList.find(
      (el) => el.slug === collectionSlug
    );

    const pageData = await getPage();

    const isPLP = pageData?.blocks?.find(
      (el) => el.type.identifier === "catalog"
    );
    if (!isPLP) {
      store.commit("general/SET_JSON_SCHEMA_DATA", {
        pageName:
          pageData?.mixedTranslation?.title ||
          pageData?.mixedTranslation?.meta_title ||
          "",
        pageImage:
          getImageByPosition(pageData?.medias, "open-graph")?.file?.url ||
          getImageByPosition(pageData?.medias, "page")?.file?.url,
      });
    }

    return {
      pageData,
      currentCollection,
    };
  },
  head() {
    const isPLP = this.pageData?.blocks?.find(
      (el) => el.type.identifier === "catalog"
    );
    const i18nHead = this.$nuxtI18nHead({
      addSeoAttributes: true,
    });
    const script = [];

    if (!isPLP) {
      const jsonLdPayload = this.setPageJsonLdSchema();
      script.push({
        hid: this.getJsonLdScriptHid(jsonLdPayload),
        type: "application/ld+json",
        json: jsonLdPayload,
      });
    }
    let metaTitle =
      this.pageData?.mixedTranslation?.meta_title ||
      this.pageData?.mixedTranslation?.title ||
      "";
    if (isPLP || this.currentCollection) {
      const pageNumberTitlePart = this.$route.query.page > 1 ? ` | ${this.$t("page")} ${this.$route.query.page}` : "";
      metaTitle =
        (this.pageData?.mixedTranslation?.meta_title ||
          this.pageData?.mixedTranslation?.title ||
          "") + pageNumberTitlePart;
    }
    return {
      meta: [
        ...metaGenerator({
          title: metaTitle,
          description: this.pageData?.mixedTranslation?.meta_description || "",
          image:
            this.pageData?.medias?.find((el) => el.position === "open-graph")
              ?.file?.url || "",
          url:
            this.pageData?.mixedTranslation?.meta_url ||
            process.env.DOMAIN + this.$route.fullPath,
        }),
        ...i18nHead.meta,
      ],
      htmlAttrs: i18nHead.htmlAttrs,
      link: i18nHead.link,
      title: metaTitle,
      titleTemplate: `%s | ${this.getCompanyName}`,
      script,
    };
  },
  computed: {
    ...mapGetters({
      getCompanyName: "general/getCompanyName",
      getMaterialsCategories: "general/getMaterialsCategories",
      getCollectionList: "general/getCollectionList",
    }),
    pageImage() {
      return this.pageData?.medias?.find((el) => el.position === "page");
    },
    canSendGoogleAnalyticsStatistic() {
      return (
        this.integrationCallbackStatuses.TYPE_GOOGLE_ANALYTICS && this.pageData
      );
    },
  },
  watch: {
    canSendGoogleAnalyticsStatistic: {
      handler() {
        if (!this.currentCollection) {
          this.gaDynamicParamsEvent(`View Other`, {
            ecomm_prodid: "",
            ecomm_pagetype: "other",
            ecomm_totalvalue: "",
            ecomm_category: "",
          });
        }
      },
      immediate: true,
    },
  },
  created() {
    const breadcrumbsData = this.getBreadcrumbs({});
    this.setBreadcrumbs(breadcrumbsData);
  },
  mounted() {
    this.visitEvent(this.pageData.is_plp);
  },
  methods: {
    setBreadcrumbs(data) {
      this.$store.commit("general/SET_BREADCRUMBS", data);
    },
    getBreadcrumbs(data) {
      return [
        {
          text: this.$t("home"),
          disabled: false,
          href: "/",
        },
        {
          text: this.pageData?.mixedTranslation?.title,
          disabled: true,
          href: this.$route.path,
        },
      ];
    },
  },
};
